window.X = 0;
window.drag = function(acao, url, total){

	var dragItem = Boss.getById('ho-overflow-size');

	var wid = dragItem.offsetWidth;

	if(dragItem){

		if(acao == 'back'){
			X = X + 50;
		}

		if(acao == 'next'){
			X = X - 50;
		}

		/* Max X Left */
		if(X >= 10){
			X = 10;
		}


		/* Max X Right */
		if(X <= (wid * -1)){
			X = (wid * -1) + 30;
		}

		dragItem.style.transform = "translate3d(" + X + "px, 0px, 0)";
	}
};

window.animaBox = {
	inner: null,
	container: null,
	config: {
		refreshRate: 1,
		counter: 0,
		perspective: 30,
	},
	mouse: {
		_x: 0,
		_y: 0,
		x: 0,
		y: 0,
		updatePosition: function(event){

			var e = event || window.event;
			this.x = e.clientX - this._x;
			this.y = (e.clientY - this._y) * -1;
		},
		setOrigin: function(e) {
			this._x = e.offsetLeft + Math.floor(e.offsetWidth / 2);
			this._y = e.offsetTop + Math.floor(e.offsetHeight / 2);
		},
		show: function() {
			return "(" + this.x + ", " + this.y + ")";
		}
	},
	isTimeToUpdate: function(){

		return animaBox.config.counter++ % animaBox.config.refreshRate === 0;
	},
	onMouseEnterHandler: function(event){
		animaBox.update(event);
	},
	onMouseLeaveHandler: function(){
		animaBox.inner.style = null;
	},
	onMouseMoveHandler: function(event){
		if(animaBox.isTimeToUpdate()){
			animaBox.update(event)
		}
	},
	update: function(event){

		animaBox.mouse.updatePosition(event);

		animaBox.updateTransformStyle(
			(animaBox.mouse.y / animaBox.inner.offsetHeight / 2).toFixed(2),
			(animaBox.mouse.x / animaBox.inner.offsetWidth / 2).toFixed(2)
		);
	},
	updateTransformStyle: function(x, y){
		var style = "rotateX(" + x + "deg) rotateY(" + y + "deg) scale3d(1, 1, 1)";

		animaBox.inner.style.willChange = 'transform';
		animaBox.inner.style.transform = style;
		animaBox.inner.style.webkitTransform = style;
		animaBox.inner.style.mozTranform = style;
		animaBox.inner.style.msTransform = style;
		animaBox.inner.style.oTransform = style;
	},
	init: function(container){

		container = Boss.getById(container);

		/* Proximo elemento ( elemento.nextSibling ) */
		var inner = container.getElementsByTagName('DIV')[0];

		if(container && inner){

			animaBox.container = container;
			animaBox.inner = inner;

			container.style.display = 'block';
			container.style.perspective = animaBox.config.perspective+'px';

			animaBox.mouse.setOrigin(container);

			container.onmousemove = animaBox.onMouseMoveHandler;
			container.onmouseleave = animaBox.onMouseLeaveHandler;
			container.onmouseenter = animaBox.onMouseEnterHandler;
		}
	}
};







window.voltarpara = function(){


	if(url == 'pc'){

		var path = window.location.pathname;

		path = path.split('/');

		var controladoratual = path[1];

		var menu = Boss.getById('box-pc-a-menu');


	}
	

};












function getXHRPopStateShowStatus(){
	return XHRPopStateShowStatus;
}

function setXHRPopStateShowStatus(st){
	XHRPopStateShowStatus = st;
}

window.goHref = function(url){
	Boss.pushstate.goXHR(url, xhrfn, lockChangePageFn);
};

window.controlador = '/';
window.controller = '/';

var xhrfn = function(controler, doneCallFn){

	var expPopstate = /!popstate+$/g;
	var expHash = /#[.*\S]+$/g;
	var expHashExtract = /#([.*\S]+)$/i;
	var atualLocation = XHRPopLastController.replace(expHash, '');

	controler = controler.replace(expPopstate, '');
	var testHash = controler;

	// SCROLL TO HASH ELEMENT
	if(expHashExtract.test(controler) === true){
		var idByHash = controler.match(expHashExtract)[1];
		if(Boss.getById(idByHash)){
			var idByHashTop = Boss.positionAtTop(Boss.getById(idByHash));
			window.scrollTo(0, idByHashTop);
		}else{
			window.scrollTo(0, XHRPopStateScroll[controler]);
		}
	}

	controler = controler.replace(expHash, '');
	controlador = controler;

	var pushLoader = Boss.getById('push-loader');
	pushLoader.style.width = '10%';
	pushLoader.style.opacity = 1;

	if(XHRPopState){
		if(typeof(XHRPopState.abort) === 'function'){
			if(getXHRPopStateShowStatus() === false){
				console.warn('Cancelando request anterior.');
			}
			setXHRPopStateShowStatus(false);
			XHRPopState.abort();
		}
	}
	
	setXHRPopStateShowStatus(false);

	XHRPopState = Boss.ajax({
		'url': controler,
		'data': {'metodo': 'ajax'},
		'dataType': 'json',
		'done': function(rtn){

			setXHRPopStateShowStatus(true);

			doneCallFn();

			pushLoader.style.width = '50%';

			if(rtn.title){
				document.title = rtn.title;
			}

			var render = Boss.getById('content');
			render.innerHTML = '';
			render.innerHTML = rtn.html;

			if(typeof(ga) !== 'undefined'){
				if(controler === jsdominio){
					gtag('config', 'UA-130312789-1', {'page_path': '/'});
				}else{
					var gasend = controler.replace(jsdominio, '');
					gasend = gasend.replace('!popstate', '');
					gtag('config', 'UA-130312789-1', {'page_path': gasend});
				}
			}

			Boss.delay(function(){

				// SCROLL TO HASH ELEMENT
				if(expHashExtract.test(testHash) === true){
					var idByHash = testHash.match(expHashExtract)[1];
					if(Boss.getById(idByHash)){
						var idByHashTop = Boss.positionAtTop(Boss.getById(idByHash));
						window.scrollTo(0, idByHashTop);
					}else{
						window.scrollTo(0, XHRPopStateScroll[testHash]);
					}
				}else{

					controlerscroll = controler.replace(/\?.*$/, '');

					if(XHRPopStateScroll[controlerscroll]){
						window.scrollTo(0, XHRPopStateScroll[controlerscroll]);
					}else if(XHRPopStateScroll['/'+controlerscroll]){
						window.scrollTo(0, XHRPopStateScroll['/'+controlerscroll]);
					}else{
						window.scrollTo(0, 0);
					}
				}

				var scripts = render.getElementsByTagName('script');
				for(x in scripts){
					eval(scripts[x].innerHTML);
				}

			}, 30);

			/* CONTROLADOR INDEX */
			if(window.location.pathname === '/' || window.location.pathname === '/mobile/'){

				pushLoader.style.width = '100%';

				Boss.delay(function(){
					pushLoader.style.opacity = 0;
				}, 500);

				if(Boss.getById('header-index-pc') && Boss.getById('header-pc-img')){
					Boss.getById('header-index-pc').classList.remove('hidden');
					/* Boss.getById('box-pc-header').classList.remove('box-pc-fixed');
					Boss.getById('box-pc-header').classList.add('box-pc-abso'); */
					
					Boss.getById('header-pc-img').classList.add('header-pc-img');
				}

				if(typeof('videoArea') !== 'undefined' && Boss.getById('videoArea')){
					Boss.getById('videoArea').classList.remove('hidden');
				}

			/* OUTROS */
			}else{

				if(Boss.getById('header-index-pc') && Boss.getById('header-pc-img')){

					Boss.getById('header-index-pc').classList.add('hidden');
					/* Boss.getById('box-pc-header').classList.add('box-pc-fixed');
					Boss.getById('box-pc-header').classList.remove('box-pc-abso'); */
					Boss.getById('header-pc-img').classList.remove('header-pc-img');
				}

				if(typeof('videoArea') !== 'undefined' && Boss.getById('videoArea')){
					Boss.getById('videoArea').classList.add('hidden');
				}
				Boss.delay(function(){

					pushLoader.style.width = '100%';

					Boss.delay(function(){
						pushLoader.style.opacity = 0;
					}, 500);

					Boss.delay(function(){
						pushLoader.style.width = '0%';
					}, 1000);
				}, 30);

				var ctrl = controler
				ctrl = ctrl.replace(jsdominio+'/mobile/', '');
				ctrl = ctrl.replace(jsdominio+'/', '');

				ctrl = ctrl.split('/');

			}

			closeMenu();
		},
		'error': function(evts){
			if(getXHRPopStateShowStatus() === true){
				Boss.warning({'message': 'Não foi possível acessar o conteúdo requisitado, há algum problema com a Internet!'});
				Boss.delay(function(){
					pushLoader.style.opacity = 0;
				}, 500);

				Boss.delay(function(){
					pushLoader.style.width = '0%';
				}, 1000);
			}
		}
	});
};

window.curY = 0;
window.lock = function(){
	curY = window.scrollY;
	document.body.classList.add('lock');
};

window.unlock = function(){
	document.body.classList.remove('lock');
	window.scrollTo(0, curY);
};

window.toggleMenuMobile = function(){

	var menu = Boss.getById('menu-mob');

	if(menu){

		if(menu.getAttribute('style') == 'display: none'){
			/* PRIMEIRA VEZ QUE ABRE MENU MOBILE */
			menu.style.display = null;
			openMenu();
		}else{
			
			if(menu.classList.contains('menu-mob-open')){
				closeMenu();
			}else{
				openMenu();
			}
		}
	}
};

window.closeMenu = function(){
	var menu = Boss.getById('menu-mob');

	if(menu){
		
		unlock();
		menu.classList.add('menu-mob-close');
		menu.classList.remove('menu-mob-open');
	}
};

window.openMenu = function(){
	var menu = Boss.getById('menu-mob');

	if(menu){

		lock();		
		menu.classList.add('menu-mob-open');
		menu.classList.remove('menu-mob-close');
	}
};

Boss.evts.add('keydown', window, function(event){
	var btn = event.keyCode;

	/* ESC */
	if(btn == 27){

		if(url === 'pc'){
			closeMenuPC();
		}

		if(url === 'mobile'){
			closeMenu();
		}
	}
});
window.getKey = function(){

	var key = localStorage.getItem("key");

	if(key){

		if(Boss.getById('int-key')){

			Boss.getById('int-key').innerHTML = key+'. ';
		}
	}
};

window.share = function(rede, link){

	if(rede == 'facebook'){

		window.open("https://www.facebook.com/share.php?u="+window.location.href+link, 'compartilhar', 'width=800, height=600, toolbar=no, top=50, left=50');
	}	

	if(rede == 'whatsapp'){

		if(url == 'mobile'){

			window.open("whatsapp://send?text="+window.location.href+link, 'compartilhar', 'width=800, height=600, toolbar=no, top=50, left=50');
		}else{

			window.open("https://web.whatsapp.com/send?text="+window.location.href+link, 'compartilhar', 'width=800, height=600, toolbar=no, top=50, left=50');
		}
	}

	if(rede == 'twitter'){

		window.open("https://twitter.com/home?status="+window.location.href+link, 'compartilhar', 'width=800, height=600, toolbar=no, top=50, left=50');
	}
};

window.setcode = function(key){

	localStorage.setItem("key", key);
};

var lastWidth = 0;
var prevScrollpos = window.pageYOffset;

var ur = window.location.pathname;
window.url = 'pc';
ur = ur.split('/');

if(ur[1] == 'mobile'){
	url = 'mobile';
}

function checkChange(){

	var timeSession = Number(localStorage.getItem('time'));

	var date = new Date;
	var agora = Date.now();

	if(!localStorage.getItem('versaoPC') && !localStorage.getItem('versaoMobile')){
		localStorage.setItem('versaoPC', 'false');
		localStorage.setItem('versaoMobile', 'false');
	}

	if(url === 'pc'){

		/* Se agora for > que o tempo da sessão, é que experou a sessão */
		if(agora > timeSession){
			localStorage.setItem('versaoPC', 'false');
		}

		if(localStorage.getItem('versaoPC') === 'true'){
			Boss.getById('box-changeMobile').classList.add('hidden');
		}else{
			Boss.getById('box-changeMobile').classList.remove('hidden');
		}

	}else{

		/* Se agora for > que o tempo da sessão, é que experou a sessão */
		if(agora > timeSession){
			localStorage.setItem('versaoMobile', 'false');
		}

		if(localStorage.getItem('versaoMobile') === 'true'){

			Boss.getById('box-changeMobile').classList.add('hidden');
		}else{
			Boss.getById('box-changeMobile').classList.remove('hidden');
		}
	}
}

function cancelChange(versao){

	var date = new Date;
	var time = Date.now();
	var limiteSession = Number(86400); /* Um dia, tempo da sessão */
	var timeSession = Number(time + limiteSession);

	if(Boss.getById('box-changeMobile')){

		Boss.getById('box-changeMobile').classList.add('hidden');
	}

	localStorage.setItem('time', timeSession);

	if(versao === 'pc'){
		localStorage.setItem('versaoPC', 'true');
	}else{
		
		localStorage.setItem('versaoMobile', 'true');
	}
}

var lockChangePageFn = function(url){
	lockChangePage = false;
	lockClosePage = false;
};
/* var lockExitMessage = false; */
Boss.pushstate.init({
	'lockExitMessage': false,
	'xhrfn': xhrfn,
	'lockChangePageFn': lockChangePageFn
});

window.busca = {
	inputSearch: Boss.getById('input-search'),
	ajax: function(value){

		value.toLowerCase();

		if(Boss.getById('loader-busca')){

			Boss.getById('loader-busca').classList.remove('hidden');
		}

		/* REMOVE TAGS HTML DO INPUT */
		var temp = document.createElement('div');
		temp.innerHTML = value;
		value = temp.textContent;

		if(value !== ''){

			var con = controlador.split('/');

			if(url == 'pc'){
				url = '/';
			}

			if(url == 'mobile'){
				url = '/mobile/';
			}

			if(url == '/mobile/'){

				if(con[3] !== 'mobile' && con[2] !== 'busca'){

					Boss.pushstate.goXHR(url+"busca/b/"+value, xhrfn, lockChangePageFn);
				}
			}

			if(url == '/'){
				if(con[1] !== 'busca'){

					Boss.pushstate.goXHR(url+"busca/b/"+value, xhrfn, lockChangePageFn);
				}
			}

			window.history.pushState("", "", url+"busca/b/"+value);

			Boss.ajax({
				url: url+'busca/busca',
				data: {'search': value},
				dataType: 'json',
				done: function(rtn){

					if(Boss.getById('totalItens') && Boss.getById('res-busca') && Boss.getById('resultados-busca')){

						var total = rtn.total;
						var html = rtn.html;

						if(Boss.getById('loader-busca')){

						 	Boss.getById('loader-busca').classList.add('hidden');
						}
						
						Boss.getById('totalItens').innerHTML = total;

						Boss.getById('res-busca').innerHTML = '';
						Boss.getById('resultados-busca').innerHTML = html;
					
					}
				}
			});
		}
	},
	init: function(){

		Boss.evts.add('keyup', busca.inputSearch, function(){

			Boss.delayPersistent2(function(){

				if(busca.inputSearch.value.length >= 3){

					busca.ajax(busca.inputSearch.value);
				}

			}, 600, 'Busca'+url);
		});
	}
};

window.busca_refresh = function(){

	Boss.delay(function(){

		if(searchBusca){

			if(typeof(busca) !== 'undefined'){

				busca.inputSearch.value = searchBusca;

				if(typeof(busca.ajax) !== 'undefined'){

					busca.ajax(busca.inputSearch.value);
				}
			}
		}

	}, 100);
};

window.openBox = function(numero){

	var box = Boss.getById('indx-plano-txt-box-'+numero);
	var icone = Boss.getById('icone-'+numero);

	if(box && icone){

		if(box.classList.contains('hidden')){

			icone.classList.remove('indx-plano-rotate-out');
			icone.classList.add('indx-plano-rotate-in');
			box.classList.remove('hidden');

			Boss.getById('box-plano-'+numero).style.border = '1px solid #aadbff';
			
		}else{

			Boss.getById('box-plano-'+numero).style.border = '1px solid #ffffff';
			box.classList.add('hidden');
			icone.classList.add('indx-plano-rotate-out');
			icone.classList.remove('indx-plano-rotate-in');
		}
	}
};

window.closeMenuPC = function(){

	var bodyC = Boss.getById('box-conteudo-body');
	var menuC = Boss.getById('box-pc-menu');
	var btnMenu = Boss.getById('btnMenuPC');

	menuC.classList.remove('box-menu-pc-open');
	menuC.classList.add('box-menu-pc-close');

	btnMenu.src = '/jnh/menu/menu-b.png';
};

window.openMenuPC = function(){

	var bodyC = Boss.getById('box-conteudo-body');
	var menuC = Boss.getById('box-pc-menu');
	var btnMenu = Boss.getById('btnMenuPC');

	menuC.classList.add('box-menu-pc-open');
	menuC.classList.remove('box-menu-pc-close');

	btnMenu.src = '/jnh/menu/close-b.png';
};

window.triggerMenuPC = function(){

	if(Boss.getById('box-pc-menu').classList.contains('box-menu-pc-open')){

		/* CLOSING */
		closeMenuPC();
	}else{

		/* OPENING*/
		openMenuPC()
	}
};

window.covid19AnimacaoT;
window.covid19Frase = 1;
window.covid19Frases = {
	1: {
		'bg': '/jnh/home/bgheader_corona2020_1.jpg',
		'frase':  'Nosso agradecimento aos<br />profissionais da saúde.',
		'hash': 'Muito obrigado'
	},
	2: {
		'bg': '/jnh/home/bgheader_corona2020_2.jpg',
		'frase':  'A prevenção é o melhor cuidado,<br/>se puder:',
		'hash': '#fiqueemcasa'
	}
};
window.covid19Animacao = function(){

	var header_pc_img = Boss.getById('header-pc-img');

	header_pc_img.style.backgroundImage = 'url('+covid19Frases[covid19Frase].bg+')';
	header_animacao_frase.innerHTML = covid19Frases[covid19Frase].frase;
	header_animacao_hash.textContent = covid19Frases[covid19Frase].hash;

	if(covid19Frase == 1){
		covid19Frase = 2;
	}else{
		covid19Frase = 1;
	}
};

//covid19Animacao();
//var covid19AnimacaoT = setInterval(covid19Animacao, 6000);

busca.init();